module.exports = __webpack_public_path__ + "static/media/logo-del@2x.09af0df6.png";